
export class Campaign {
	public campaignID: string;
	public campaignName: string;
	public eMailContent: string;
	public emailJSON: string;
	public eMailSubject: string;
	public smsMessage: string;
	public adminUserID: string;
	public emailTypeID: EmailType;
	public emailTypeDesc: string;
	public deliveryDateTime: Date;
	public campaignStatusID: CampaignStatus;
	public campaignStatusDesc: string;
	public vimeoVideoUrl: string;
	public sendAllEmployers: boolean;
	public employers: Array<string>;
	public employer: string;
	// 1 = Designer (Unlayer; emailJSON is the source), 2 = HTML (expert mode; eMailContent is the source).
	public editorTypeID: number = 1;

	public startDripDate: Date;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

export enum CampaignStatus {
	Active = 1,
	Executing = 2,
	Complete = 3,
	Inactive = 4
}

export enum EmailType {
	Single = 1,
	Drip = 2,
}

export class DripProgram {
	public dripProgramID: string;
	public dripProgramName: string;
	public dripProgramDesc?: string;
	public employerID: string;
	public startDate: Date;
	public deliveryTime: string;
	public paused: boolean;
	public catchUpInterval: number;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

export class DripProgramDetails {
	public dripProgramID: string;
	public campaignID: string;
	public sequence: number;
	public interval: number;
	public catchup: boolean;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

// Body for POST campaigns/dripprogram/{id}/copy. employerID (optional) is assigned to the new program.
export interface DripProgramCopyRequest {
	newDripProgramID: string;
	newDripProgramDesc: string;
	employerID?: string | null;
}

// GET campaigns/dripprogram/{id}/campaign/{campaignID}/context: what editing this step from inside
// the program will do (edit in place vs. create a private copy vs. blocked because already sent).
export interface DripCampaignEditContext {
	dripProgramID: string;
	dripProgramDesc: string;
	isDefaultProgram: boolean;
	sequence: number | null;
	otherProgramCount: number;
	otherProgramNames: string | null;
	sentToProgramEmployers: boolean;
	sentEmployerNames: string | null;
}
